export default "__VITE_ASSET__BP7nQ4Ux__"